import type { ReactNode } from "react";
import { ChevronDown } from "lucide-react";

export function SettingsSectionHeading({ children, expanded, contentId, label, disabled = false, onToggle }: {
  children: ReactNode; expanded: boolean; contentId: string; label: string; disabled?: boolean; onToggle: () => void;
}) {
  return <button className="catalog-collapse-toggle settings-heading-toggle" type="button" disabled={disabled} aria-expanded={expanded} aria-controls={contentId} aria-label={`${expanded ? "Collapse" : "Expand"} ${label}`} onClick={onToggle}>
    <span className="settings-heading-content">{children}</span>
    <ChevronDown className="settings-heading-chevron" size={20} aria-hidden="true" />
  </button>;
}
